import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "order-status-color" }, null, -1)
const _hoisted_2 = { class: "ib-title summary-section flex-row flex-justify-sb" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Order Summary", -1)
const _hoisted_4 = { id: "summaryStatusText" }
const _hoisted_5 = {
  class: "summary-section",
  id: "orderItems"
}
const _hoisted_6 = {
  key: 0,
  class: "summary-section summary-totals bar-top"
}
const _hoisted_7 = { class: "summary-section summary-totals" }
const _hoisted_8 = {
  key: 0,
  class: "summary-line flex-row flex-justify-sb"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Discounts", -1)
const _hoisted_10 = { class: "summary-line flex-row flex-justify-sb" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Subtotal", -1)
const _hoisted_12 = { class: "summary-line flex-row flex-justify-sb" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Taxes & Fees", -1)
const _hoisted_14 = { id: "feeBreakdown" }
const _hoisted_15 = {
  key: 0,
  class: "fee-breakdown"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "fw-medium" }, "Taxes & Fees", -1)
const _hoisted_17 = {
  key: 1,
  class: "flex center v-center",
  style: {"height":"25px"}
}
const _hoisted_18 = {
  key: 2,
  class: "summary-line flex-row flex-justify-sb fw-heavy summary-balance"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Balance Due", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cart_item = _resolveComponent("cart-item")!
  const _component_gift_card_payment = _resolveComponent("gift-card-payment")!
  const _component_cart_promo = _resolveComponent("cart-promo")!
  const _component_currency = _resolveComponent("currency")!
  const _component_loader_display = _resolveComponent("loader-display")!

  return (_openBlock(), _createElementBlock("div", {
    id: "orderSummary",
    class: _normalizeClass(["info-box flex-col", _ctx.orderStatus])
  }, [
    _hoisted_1,
    _createElementVNode("span", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.orderStatus), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createBlock(_component_cart_item, {
          key: item.OrderEntityKey,
          item: item
        }, null, 8, ["item"]))
      }), 128))
    ]),
    (!_ctx.isLoading && _ctx.activeOrder.paymentDue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "action-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openGiftCard = !_ctx.openGiftCard))
          }, "Apply gift card"),
          _createElementVNode("div", {
            class: _normalizeClass(["gc-entry", { open: _ctx.openGiftCard }])
          }, [
            _createVNode(_component_gift_card_payment)
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.activeOrder.paymentDue)
      ? (_openBlock(), _createBlock(_component_cart_promo, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.activeOrder.discountTotal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", null, [
              _createTextVNode("-"),
              _createVNode(_component_currency, {
                amount: _ctx.activeOrder.discountTotal
              }, null, 8, ["amount"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", null, [
          _createVNode(_component_currency, {
            amount: _ctx.activeOrder.subtotal
          }, null, 8, ["amount"])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", null, [
            _createVNode(_component_currency, { amount: _ctx.feesTotal }, null, 8, ["amount"])
          ]),
          (_ctx.feesTotal > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeOrder.fees, (fee) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex-row flex-justify-sb",
                    key: fee.FeeKey
                  }, [
                    _createElementVNode("span", null, _toDisplayString(fee.FeeName), 1),
                    _createVNode(_component_currency, {
                      amount: fee.Amount
                    }, null, 8, ["amount"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_loader_display, { small: true })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", null, [
              _createVNode(_component_currency, { amount: _ctx.balanceDue }, null, 8, ["amount"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}